import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1.7rem 0 3rem 0;
	font-size: 11px;
	font-weight: 600; 
	margin-top: 1.3rem;
`


export const Pragraph = styled.p`
	color: #545454;
`